import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';

import AngleIcon from 'images/icon/angle-left.inline.svg';

import { useElement } from 'util/event';

import styles from './index.css';
import { useAccordion } from './hook';

const Accordion = ({
	className,
	contentClassName,
	headClassName,
	defaultHeight = 24,
	onUpdateHeight,
	title,
	titleUrl,
	children,
	disabled = false,
	onClickTitle = () => {},
}) => {
	const { refChild, height } = useElement({ defaultHeight, onUpdateHeight });
	const [{ dropdown, visible }, onToggle] = useAccordion({ disabled });

	return (
		<div
			className={classnames(styles.accordion, className, {
				[styles.dropdown]: dropdown,
				[styles.visible]: dropdown && visible,
				[styles.disabled]: disabled,
			})}
			style={{ height: dropdown ? height + defaultHeight : defaultHeight }}
		>
			<div className={classnames(styles.head, headClassName)}>
				{titleUrl ? (
					<Link to={titleUrl} onClick={onClickTitle}>
						{title}
					</Link>
				) : (
					<span>{title}</span>
				)}
				{!disabled && (
					<button
						type="button"
						className={classnames({ [styles.dropdown]: dropdown })}
						onClick={onToggle}
					>
						<AngleIcon />
					</button>
				)}
			</div>
			<div className={contentClassName} ref={refChild}>
				{children}
			</div>
		</div>
	);
};

export default Accordion;
